import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {checkPermissionStartingTree, isEmpty} from "../../../../_helpers/commonFunctions";
import SidebarLabel from "../SidebarLabel";
import SideBarLink from "../SidebarLinks";
import {
    productsPathConfig,
    salesPathConfig,
    buysPathConfig,
    clientsPathConfig,
    cashRegistersConfig,
    settingsPathConfig, accountingPathConfig, suppliersPathConfig, payrollPathConfig, prescriptionPathConfig,
    fixedAssetsPathConfig,
} from "./config";
import "./index.css";
import {activePath} from "../../../../_reducers/Navbar";
import TreeView from "../../data-panel/Cloud/TreeView/TreeView";
import PrescriptionSidebar from "../../data-panel/Prescriptions/prescription-sidebar";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import {setSlideBarToggle} from "../../../../_reducers/activitySlice";
import {useTranslation} from "../../../../hooks/useTranslation";

const Sidebar = ({permissionsData}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const MOBILE_SIDEBAR_TOGGLE = useSelector((state) => state.MOBILE_SIDEBAR_TOGGLE);
    const ACTIVE_PATH = useSelector((state) => state.ACTIVE_PATH);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const isMobileScreen = useMediaQuery("(max-width: 980px)");
    const [escapeNav, setEscapeNav] = useState(false);

    const companyHasPrescription = useSelector((state) => state.PRESCRIPTION.companyHasPrescription);
    const prescriptionPathConfigRefined = companyHasPrescription ? prescriptionPathConfig : prescriptionPathConfig.filter((el) => !el.dontShow);

    const slideBarToggle = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarToggle);
    const slideBarOpen = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarOpen);

    const activeListMapping = {
        "Products" : productsPathConfig,
        "Sales" : salesPathConfig,
        "Buys" : buysPathConfig,
        "Clients" : clientsPathConfig,
        "Suppliers" : suppliersPathConfig,
        "Cash" : cashRegistersConfig,
        "Settings" : settingsPathConfig,
        "Accounting" : accountingPathConfig,
        "Payroll": payrollPathConfig,
        "Prescription": prescriptionPathConfigRefined,
        "FixedAssets": fixedAssetsPathConfig,
    }

    const renderSidebarFunc = () => {
        const activeLink = ACTIVE_PATH || "";
        const sideBarContent = activeListMapping[activeLink] || [];
        return (
            <SidebarLabel labelName={activeLink} labelDesc={activeLink === "Cash" ? t("NavBar.cash") : activeLink ? t(activeLink.toString()) : activeLink}>
                {sideBarContent.map((pathConfig, i) => {
                    if (checkPermissionStartingTree(pathConfig.permission, permissionsData)) {
                        return (
                            <SideBarLink
                                key={i}
                                id={pathConfig.id}
                                title={t(pathConfig.title)}
                                linksInfo={pathConfig.linkInfo}
                                requirement={pathConfig.requirement}
                                permissionsData={permissionsData}
                            />
                        )
                    }
                    return <React.Fragment></React.Fragment>;
                })}
                {isMobileScreen && (
                    <li style={{cursor: "pointer"}} className="nav-item border-bottom-1-gray" onClick={() => setEscapeNav(false)}>
                        <div className="nav-link">
                            <i className="menu-arrow menu-arrow-back"></i>
                            <span className="menu-title">Πίσω</span>
                        </div>
                    </li>
                )}
            </SidebarLabel>
        )
    }

    const handleClickMobileSidebar = (activeLink) => {
        setEscapeNav(true);
        dispatch(activePath(activeLink));
    }

    const isInCloudTab = TABS_DATA[ACTIVE_MAIN_TAB]?.tabType === "cloud";

    return (
        <React.Fragment>
            {isMobileScreen ? (
                <nav className={`sidebar sidebar-offcanvas ${MOBILE_SIDEBAR_TOGGLE && "active"}`} id="sidebar" style={{zIndex: "1000", marginTop: "20px"}}>
                    {!escapeNav && (
                        <div className="tab-content active">
                            <ul className="nav" id={`menu-Menu`}>
                                <li className="nav-label">Μενού</li>
                                {Object.keys(activeListMapping).map((key, idx) => {
                                    if (permissionsData?.some((el) => activeListMapping[key].some((el2) => String(el.permissionName).startsWith(el2.permission))) || checkPermissionStartingTree(activeListMapping[key].permission, permissionsData)) {
                                        return (
                                            <li onClick={() => handleClickMobileSidebar(key)} style={{cursor: "pointer"}} className="nav-item border-bottom-1-gray" key={`mobileSideBar${key}${idx}`}>
                                                <div className="nav-link" data-toggle="collapse">
                                                    <span className="menu-title">{key === "Cash" ? t("NavBar.cash") : t(key)}</span>
                                                    <i className="menu-arrow"></i>
                                                </div>
                                            </li>
                                        )
                                    }
                                    return <React.Fragment></React.Fragment>;
                                })}
                            </ul>
                            <div className="sidebar-scroll-buffer"></div>
                        </div>
                    )}
                    {escapeNav && (
                        <div className="tab-content active">
                            <ul className="nav" id={`menu-Menu`}>
                                <li className="nav-label">{!isEmpty(ACTIVE_PATH) ? t(String(ACTIVE_PATH)) : ""}</li>
                                {!isEmpty(ACTIVE_PATH) && Object.keys(activeListMapping[ACTIVE_PATH]).map((key, idx) => {
                                    if (checkPermissionStartingTree(activeListMapping[ACTIVE_PATH][key].permission, permissionsData)) {
                                        return (
                                            <SideBarLink
                                                key={idx}
                                                id={activeListMapping[ACTIVE_PATH][key].id}
                                                title={t(activeListMapping[ACTIVE_PATH][key].title)}
                                                linksInfo={activeListMapping[ACTIVE_PATH][key].linkInfo}
                                                requirement={activeListMapping[ACTIVE_PATH][key].requirement}
                                                permissionsData={permissionsData}
                                            />
                                        )
                                    }
                                    return <React.Fragment></React.Fragment>;
                                })}
                                <li style={{cursor: "pointer"}} className="nav-item border-bottom-1-gray sidebar-mobile-back" onClick={() => setEscapeNav(false)}>
                                    <div className="nav-link">
                                        <i className="menu-arrow menu-arrow-back"></i>
                                        <span className="menu-title">Πίσω</span>
                                    </div>
                                </li>
                            </ul>
                            <div className="sidebar-scroll-buffer"></div>
                        </div>
                    )}
                </nav>
            ) : (
                <nav className={`sidebar sidebar-offcanvas ${MOBILE_SIDEBAR_TOGGLE && "active"}`} id="sidebar"
                     onMouseEnter={() => !slideBarOpen && dispatch(setSlideBarToggle(false))}
                     onMouseLeave={() => !slideBarOpen && dispatch(setSlideBarToggle(true))}
                     style={{
                         top: "70px",
                         width: slideBarToggle ? "50px" : ""
                    }}
                >
                    <div className="tab-content" style={{display: slideBarToggle ? "none" : "block"}}>
                        {renderSidebarFunc(ACTIVE_PATH)}
                        {isInCloudTab && (
                            <TreeView />
                        )}
                        {ACTIVE_PATH === "Prescription" && (
                            <PrescriptionSidebar />
                        )}
                        <div className="sidebar-scroll-buffer"></div>
                    </div>
                </nav>
            )}
        </React.Fragment>
    )
}

export default Sidebar;
